const ChevronRight = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.23271 4.20694C8.53263 3.92125 9.00737 3.93279 9.29306 4.23271L14.2944 9.48318C14.5703 9.77285 14.5703 10.2281 14.2944 10.5178L9.29306 15.7682C9.00737 16.0681 8.53263 16.0797 8.23271 15.794C7.93279 15.5083 7.92125 15.0336 8.20694 14.7336L12.7155 10.0005L8.20694 5.26729C7.92125 4.96737 7.93279 4.49264 8.23271 4.20694Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ChevronRight;
